module.exports = __webpack_public_path__ + "static/media/up-rating-coffee.5696dd50.svg";